import { render } from "./RemoteMonitoringEventItem.vue?vue&type=template&id=07623b0d&ts=true"
import script from "./RemoteMonitoringEventItem.vue?vue&type=script&lang=ts"
export * from "./RemoteMonitoringEventItem.vue?vue&type=script&lang=ts"

import "./RemoteMonitoringEventItem.vue?vue&type=style&index=0&id=07623b0d&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__